/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createRunDetail = /* GraphQL */ `
  mutation CreateRunDetail(
    $input: CreateRunDetailInput!
    $condition: ModelRunDetailConditionInput
  ) {
    createRunDetail(input: $input, condition: $condition) {
      id
      run_id
      event_id
      group_id
      runJson
      runNotes
      runTimings
      racerFacts
      isProdReady
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const updateRunDetail = /* GraphQL */ `
  mutation UpdateRunDetail(
    $input: UpdateRunDetailInput!
    $condition: ModelRunDetailConditionInput
  ) {
    updateRunDetail(input: $input, condition: $condition) {
      id
      run_id
      event_id
      group_id
      runJson
      runNotes
      runTimings
      racerFacts
      isProdReady
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const deleteRunDetail = /* GraphQL */ `
  mutation DeleteRunDetail(
    $input: DeleteRunDetailInput!
    $condition: ModelRunDetailConditionInput
  ) {
    deleteRunDetail(input: $input, condition: $condition) {
      id
      run_id
      event_id
      group_id
      runJson
      runNotes
      runTimings
      racerFacts
      isProdReady
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const createEventList = /* GraphQL */ `
  mutation CreateEventList(
    $input: CreateEventListInput!
    $condition: ModelEventListConditionInput
  ) {
    createEventList(input: $input, condition: $condition) {
      id
      eventId
      eventVenue
      eventName
      runList
      eventStartDate
      eventEndDate
      eventJson
      eventSource
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const updateEventList = /* GraphQL */ `
  mutation UpdateEventList(
    $input: UpdateEventListInput!
    $condition: ModelEventListConditionInput
  ) {
    updateEventList(input: $input, condition: $condition) {
      id
      eventId
      eventVenue
      eventName
      runList
      eventStartDate
      eventEndDate
      eventJson
      eventSource
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const deleteEventList = /* GraphQL */ `
  mutation DeleteEventList(
    $input: DeleteEventListInput!
    $condition: ModelEventListConditionInput
  ) {
    deleteEventList(input: $input, condition: $condition) {
      id
      eventId
      eventVenue
      eventName
      runList
      eventStartDate
      eventEndDate
      eventJson
      eventSource
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const createSessionList = /* GraphQL */ `
  mutation CreateSessionList(
    $input: CreateSessionListInput!
    $condition: ModelSessionListConditionInput
  ) {
    createSessionList(input: $input, condition: $condition) {
      id
      eventId
      sessionStart
      sessionEnd
      trackConfig
      sessionName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const updateSessionList = /* GraphQL */ `
  mutation UpdateSessionList(
    $input: UpdateSessionListInput!
    $condition: ModelSessionListConditionInput
  ) {
    updateSessionList(input: $input, condition: $condition) {
      id
      eventId
      sessionStart
      sessionEnd
      trackConfig
      sessionName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const deleteSessionList = /* GraphQL */ `
  mutation DeleteSessionList(
    $input: DeleteSessionListInput!
    $condition: ModelSessionListConditionInput
  ) {
    deleteSessionList(input: $input, condition: $condition) {
      id
      eventId
      sessionStart
      sessionEnd
      trackConfig
      sessionName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const createVideoData = /* GraphQL */ `
  mutation CreateVideoData(
    $input: CreateVideoDataInput!
    $condition: ModelVideoDataConditionInput
  ) {
    createVideoData(input: $input, condition: $condition) {
      id
      username
      drivername
      carNum
      cameraAngle
      sccaid
      nasaid
      greenFlag
      crossStart
      eventId
      runId
      sessionId
      vidSource
      srcVideoFormattedName
      tempLocalVideoLink
      tempLocalVideoUploadStatus
      vidUploadInitiated
      tempLocalTelemetryLink
      tempLocalTelemetryUploadStatus
      tracksideVideoUrl
      tracksideVideoUploadStatus
      tracksideTelemetryUrl
      tracksideTelemetryUploadStatus
      streamUrl
      youtubeStreamUrl
      telemetryS3Key
      laptimeData
      groups
      auditStatus
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const updateVideoData = /* GraphQL */ `
  mutation UpdateVideoData(
    $input: UpdateVideoDataInput!
    $condition: ModelVideoDataConditionInput
  ) {
    updateVideoData(input: $input, condition: $condition) {
      id
      username
      drivername
      carNum
      cameraAngle
      sccaid
      nasaid
      greenFlag
      crossStart
      eventId
      runId
      sessionId
      vidSource
      srcVideoFormattedName
      tempLocalVideoLink
      tempLocalVideoUploadStatus
      vidUploadInitiated
      tempLocalTelemetryLink
      tempLocalTelemetryUploadStatus
      tracksideVideoUrl
      tracksideVideoUploadStatus
      tracksideTelemetryUrl
      tracksideTelemetryUploadStatus
      streamUrl
      youtubeStreamUrl
      telemetryS3Key
      laptimeData
      groups
      auditStatus
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const deleteVideoData = /* GraphQL */ `
  mutation DeleteVideoData(
    $input: DeleteVideoDataInput!
    $condition: ModelVideoDataConditionInput
  ) {
    deleteVideoData(input: $input, condition: $condition) {
      id
      username
      drivername
      carNum
      cameraAngle
      sccaid
      nasaid
      greenFlag
      crossStart
      eventId
      runId
      sessionId
      vidSource
      srcVideoFormattedName
      tempLocalVideoLink
      tempLocalVideoUploadStatus
      vidUploadInitiated
      tempLocalTelemetryLink
      tempLocalTelemetryUploadStatus
      tracksideVideoUrl
      tracksideVideoUploadStatus
      tracksideTelemetryUrl
      tracksideTelemetryUploadStatus
      streamUrl
      youtubeStreamUrl
      telemetryS3Key
      laptimeData
      groups
      auditStatus
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const createUserProfile = /* GraphQL */ `
  mutation CreateUserProfile(
    $input: CreateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    createUserProfile(input: $input, condition: $condition) {
      id
      name
      username
      sccaid
      nasaid
      htrDevice
      raceHeroName
      profileImage
      sponsor
      owner
      groups
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateUserProfile = /* GraphQL */ `
  mutation UpdateUserProfile(
    $input: UpdateUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    updateUserProfile(input: $input, condition: $condition) {
      id
      name
      username
      sccaid
      nasaid
      htrDevice
      raceHeroName
      profileImage
      sponsor
      owner
      groups
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteUserProfile = /* GraphQL */ `
  mutation DeleteUserProfile(
    $input: DeleteUserProfileInput!
    $condition: ModelUserProfileConditionInput
  ) {
    deleteUserProfile(input: $input, condition: $condition) {
      id
      name
      username
      sccaid
      nasaid
      htrDevice
      raceHeroName
      profileImage
      sponsor
      owner
      groups
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
